'use client';

import { useField } from 'formik';
import { FC } from 'react';

import { ControlInputGroup } from './ControlInput/ControlInputGroup';
import { InputFormikProps } from './Input.type';

/**
 * InputRadio field expected to be used within a Formik context
 */

type Props = Prettify<Omit<InputFormikProps<typeof ControlInputGroup>, 'type'>>;

export const InputRadioFormik: FC<Props> = (props) => {
  const [field, meta, helpers] = useField<string>(props.name);

  return (
    <ControlInputGroup
      {...props}
      type="radio"
      value={field.value}
      error={meta.error && meta.touched ? meta.error : undefined}
      onChange={(value) => helpers.setValue(value)}
    />
  );
};
